import SetPasswordRoute from "./SetPasswordRoute";
import setpassword_reducer from "./slice";
import setpasswordSaga from "./saga";

export { setpassword_reducer, setpasswordSaga };
export default SetPasswordRoute;
